import React from "react";
import Kohinoor1 from "../../../images/KBS1.jpg";
import Kohinoor2 from "../../../images/KBS2.jpg";
import Kohinoor3 from "../../../images/KBS3.jpg";
import Kohinoor4 from "../../../images/KBS4.jpg";
import Kohinoor5 from "../../../images/KBS5.jpg";
import Kohinoor6 from "../../../images/KBS6.jpg";
import Kohinoor7 from "../../../images/KBS7.jpg";
import Kohinoor8 from "../../../images/KBS8.jpg";
import Kohinoor9 from "../../../images/KBS9.jpg";
import Kohinoor10 from "../../../images/KBS10.jpg";
import EngagementCarouselPage from "../../ui/EngagementCarouselPage";

const Kohinoor = () => (
  <EngagementCarouselPage
    title="Kohinoor Business School"
    paragraphs={[
      "We tied up with Business Schools to organise a day of exchange between the business school students and a few underprivileged kids. Through the course of the day, we played games, danced to music and shared stories.",
    ]}
    images={[Kohinoor1, Kohinoor2, Kohinoor3, Kohinoor4, Kohinoor5, Kohinoor6, Kohinoor7, Kohinoor8, Kohinoor9, Kohinoor10]}
  />
);

export default Kohinoor;
